import {
  Component,
  OnInit,
  AfterViewChecked,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  forwardRef,
  Provider,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import {
  UtilService,
  NotificationService,
  DialogService,
  PagedSearch,
  DatagridService,
  PagedResultGeneric,
  PagedResult,
} from '../../shared/index'; //app/shared/index barrel;
import { ProfileSearchService } from '../search/profile-search.service';
import { ProfileService } from '../shared/profile.service';
import { ProfileMin } from '../shared/profile-min.model';
import { ProfileSearchParams } from '../search/profile-search-params.model';
import { ProfileSearchResult } from '../search/profile-search-result.model';
import { TranslateService } from '@ngx-translate/core';
import {
  NumberValueAccessor,
  CreateNumberValueAccessorProvider,
  CreateNumberValueValidationProvider,
} from '../../shared/widgets/value-accessors/number-value-accessor';

@Component({
  selector: 'wl-profile-dup-checker',
  templateUrl: 'profile-dup-checker.component.html',
  styleUrls: ['profile-dup-checker.component.css'],
  providers: [ProfileSearchService, ProfileService],
  standalone: false
})
export class ProfileDupCheckerComponent implements OnInit {
  @Output() onProfileSelected = new EventEmitter<ProfileMin>();

  public _utilService: UtilService;
  public _profileSearchService: ProfileSearchService;
  public _dialogService: DialogService;
  public _profileService: ProfileService;
  public _translateService: TranslateService;
  public _lastValue: number;

  public searchHasResults: boolean;
  public profileSearchParams: ProfileSearchParams;
  public profileResults: PagedResultGeneric<ProfileMin>;
  public errorMessage: string;
  public searchPerformed: boolean;
  public isSearching: boolean;
  public profileName: string;
  public displayName: string;
  @Input() sourceModule: string = ''; // for styling leave empty if you don't care

  public selectedProfile: ProfileMin;
  public showResults: boolean;

  public constructor(
    utilService: UtilService,
    translateService: TranslateService,
    profileSearchService: ProfileSearchService,
    dialogService: DialogService,
    profileService: ProfileService
  ) {
    this._utilService = utilService;
    this._translateService = translateService;
    this._profileSearchService = profileSearchService;
    this._dialogService = dialogService;
    this._profileService = profileService;

    this.profileSearchParams = new ProfileSearchParams();
    this.profileSearchParams.Keyword = '';
    this.profileResults = new PagedResult();
    this.searchHasResults = false;
    this.searchPerformed = false;
    this.isSearching = false;
    this.profileName = '';
    this.displayName = '';
    this._lastValue = -1;
    this.selectedProfile = new ProfileMin();
    this.showResults = false;
  }

  public ngOnInit() {}

  public getPossibleDuplicates = (name: string): Promise<PagedResultGeneric<ProfileMin>> => {
    return this._profileSearchService.getPossibleDuplicates(name).then((data: PagedResultGeneric<ProfileMin>) => {
      this.profileResults = data;
      return Promise.resolve(data);
    });
  };

  public show() {
    this.showResults = true;
  }
  public hide() {
    this.showResults = false;
  }

  public selectProfile = (profile: ProfileMin): void => {
    this.onProfileSelected.emit(profile);
    this.showResults = false;
  };
}
